import React from "react";

class Home extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="page-image" />
        <div className="row container section">
          <h5 className="header">About Us</h5>
          <p className="p-home-page">
            <strong>Growth Property Group LLC </strong>
            &nbsp;(GPG) is a private real estate investment firm based in
            New York City. Since 2020, GPG has been active in the acquisition,
            development, redevelopment, and management of single-tenant retail
            properties throughout the United States. GPG leverages its extensive
            industry relationships and market knowledge to identify and acquire
            high-quality retail assets that generate stable, long-term cash
            flows with strong growth potential.
          </p>
          <br />
          <p className="p-home-page">
            {/* [Since its inception, GPG has acquired more than
            400 properties in 35 states with a total estimated value of over $1
            billion, encompassing more than five million square feet of retail
            space. Our current portfolio consists of over 220 properties in 34
            states totaling 4.3 million square feet, valued at approximately
            $850 million.] */}
          </p>
          <br />
          <p className="p-home-page">
            {/* Since its inception, GPG has completed sale-leaseback transactions
            with May Department/Payless stores - $75 million (116 stores), Rite
            Aid Corporation - $190 million (64 stores), Pier 1 Imports - $100
            million (75 stores), Fleming Companies - $27 million (9 stores), and
            Office Depot - $22 million (5 stores). */}
            
          </p>
        </div>
      </div>
    );
  }
}

export default Home;
